<template>
  <div class="delivery_oplata" style="margin-top: 0">
    <div class="do_title">
      <slot name="back"></slot>
      <span>{{ text('screen_select_area') }}</span>
    </div>
    <div class="delivery_oplata_list" :class="{'delivery_oplata_list_selected': selected}">

      <label :class="{'dos_block_with_children':deliveryArea.types.length !== 0}" class="dol_block"
             v-for="(deliveryArea) in deliveryAreas">
        <input :checked="selected && deliveryArea.id === selected.id" :value="deliveryArea.id" name="delivery_service"
               type="radio"
               v-on:change="update(deliveryArea)">
        <div class="dol_content">
          <div class="dol_inner">
            <div class="dol_name">
              {{ deliveryArea.name }}
            </div>
            <div class="dol_dop">
              <div class="dol_dop_text"> {{ deliveryArea.description }}</div>
            </div>
          </div>
        </div>

        <template v-if="deliveryArea.types.length !== 0">
          <transition-group name="list">
            <label :key="deliveryArea.id + '_' + deliveryAreaType.id" class="dol_block dos_block"
                   v-for="(deliveryAreaType) in deliveryArea.types"
                   v-show="selected && deliveryArea.id === selected.id">
              <input :checked="selectedType && deliveryAreaType.id === selectedType.id" :value="deliveryAreaType.id"
                     name="delivery_service_type"
                     type="radio"
                     v-on:change="updateType(deliveryAreaType)">
              <div class="dol_content dos_content">
                <div class="dol_inner">
                  <div class="dol_name">
                    {{ deliveryAreaType.name }}
                  </div>
                  <div class="dol_dop" style="visibility: visible; opacity: 1; height: auto">
                    <div class="dol_dop_text"> {{ deliveryAreaType.description }}</div>
                  </div>
                </div>
              </div>
            </label>
          </transition-group>
        </template>
      </label>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'DeliveryAreas',
    props: {
      deliveryAreas: Array,
      selected: Object,
      selectedType: Object
    },
    methods: {
      update(deliveryArea) {
        this.$emit('update:selectedType', deliveryArea.types.length === 0 ? null : deliveryArea.types[0])
        this.$emit('update:selected', deliveryArea)
      },
      updateType(deliveryAreaType) {
        this.$emit('update:selectedType', deliveryAreaType)
      }
    }
  }
</script>

<style scoped>
  .do_title {
    padding-left: 10px;
  }

  .delivery_oplata_list {
    padding: 15px 10px;
    margin-top: unset;
  }

  .delivery_oplata_list_selected {
    margin-bottom: 90px;
  }
  
</style>
